import * as React from 'react';

import { compose, setDisplayName } from 'recompose';

import type { InjectedRouter } from 'js/lib/connectToRouter';
import connectToRouter from 'js/lib/connectToRouter';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { CourseraPlusEnrollButtonContent as CourseraPlusEnrollButton } from 'bundles/coursera-plus-landing-page/components/CourseraPlusEnrollButton';
import type { PropsFromCaller } from 'bundles/coursera-plus-landing-page/components/CourseraPlusEnrollButton';
import { useLandingPageData } from 'bundles/coursera-plus-landing-page/contentfulData/useLandingPageData';

type PropsFromRouter = {
  router: InjectedRouter;
};

type PropsToComponent = PropsFromCaller & PropsFromRouter;

export const EnrollButton = (props: PropsToComponent) => {
  const landingPageData = useLandingPageData();
  const controller = landingPageData.pageController;
  const landingPageExtended = controller.landingPageExtended;
  const {
    isCourseraPlusOwner,
    isCourseraLiteOwner,
    primaryProductItemId,
    prices,
    existingCourseraLiteSubscription,
    landingPage,
  } = landingPageExtended;
  let productPrice = props.productItemId === primaryProductItemId ? prices.primaryPrice : prices.secondaryPrice;
  // Coursera Lite learners are not eligible for promos, so we display the original
  // instead of the discounted price for them
  if (isCourseraLiteOwner) {
    productPrice = props.productItemId === primaryProductItemId ? prices.primaryOriginalPrice : prices.secondaryPrice;
  }

  const completedProps = {
    ...props,
    ownsCourseraPlus: isCourseraPlusOwner,
    ownsCourseraLite: isCourseraLiteOwner,
    productPrice,
    existingCourseraLiteSubscription,
    bundleId: landingPage.slug,
  };

  return <CourseraPlusEnrollButton {...completedProps} />;
};

export default compose<PropsToComponent, PropsFromCaller>(
  setDisplayName('CourseraPlusEnrollButton'),
  connectToRouter<PropsToComponent, PropsFromCaller>((router) => ({ router }))
)(EnrollButton);
